module.exports = __webpack_public_path__ + "img/bg-new.055a350f.png";